import { faStar as fasStar } from "@fortawesome/free-regular-svg-icons";
import {
  faFileAlt,
  faSearch,
  faStar,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
  customFormulaPostAction,
  favoriteFormulaPostAction,
  getCustomFormula,
  setActiveCustomFormula,
} from "../../actions/formulaAction";
import Loader from "../../components/Loader";
import { getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import NotePopup from "./NotePopup";

const CustomListTab = () => {
  const formulaList = useSelector(
    (state) => state.formula.present.customFormulaList
  );
  const [filteredList, setFilteredList] = useState([]);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [activeNoteID, setActiveNoteId] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getCustomFormula(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(formulaList);
  }, [formulaList]);

  const toggleFavorite = (id, active) => {
    let actionName = active ? "deleteFavFormula" : "addFavFormula";
    const data = {
      formula_id: id,
      action: actionName,
      custom: "1",
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };

    dispatch(
      favoriteFormulaPostAction(params, () => {
        dispatch(getCustomFormula());
      })
    );
  };

  const deleteFormula = (id) => {
    const data = {
      formula_id: id,
      action: "deleteCustomFormula",
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };

    dispatch(
      customFormulaPostAction(params, () => {
        dispatch(getCustomFormula());
      })
    );
  };

  const handleChange = (e) => {
    let searchTerm = e.target.value;
    let newList = formulaList.filter((x) =>
      x.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredList(newList);
  };

  const setActiveNote = (id) => {
    setActiveNoteId(id);
    setShowNotePopup(true);
  };

  const modifyAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div className="action-btn-wrapper row">
        <button
          className="btn-orange btn-table "
          onClick={() => {
            dispatch(setActiveCustomFormula(row));
            history.push("/app/formulas/create");
          }}
        >
          Modify
        </button>
      </div>
    );
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    // {
    //   dataField: "isFavorite",
    //   text: "Favorite",
    //   sort: true,
    //   formatter: (cell, row, rowIndex, formatExtraData) => {
    //     return (
    //       <FontAwesomeIcon
    //         icon={row.isFavorite ? faStar : fasStar}
    //         onClick={() => toggleFavorite(row.id, row.isFavorite)}
    //       />
    //     );
    //   },
    // },
    {
      text: "notes",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => setActiveNote(row.id)}
          />
        );
      },
    },
    {
      text: "Action",
      formatter: modifyAction,
    },
    {
      text: "Delete",

      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faTimesCircle}
            onClick={() => deleteFormula(row.id)}
          />
        );
      },
    },
  ];

  return (
    <div>
      {isLoading && <Loader />}
      {showNotePopup && (
        <NotePopup
          formulaId={activeNoteID}
          previousNote={filteredList.find((x) => x.id === activeNoteID).notes}
          closePopup={() => setShowNotePopup(false)}
        />
      )}
      <div className="d-flex justify-content-between">
        <p className="page-desc">
          Select or search your Custom Formulas, create new ones or add Classic
          Formulas to an existing Formula.
        </p>
        <div className="col-md-6 d-flex justify-content-end align-items-center">
          <button
            className="btn-orange"
            onClick={() => history.push("/app/formulas/create")}
          >
            Create New
          </button>
        </div>
      </div>

      {formulaList.length > 0 ? (
        <>
          <div className="row mt-1">
            <div className="col-md-6">
              <div className="form-group search">
                <div>
                  <label htmlFor="search">Search: (Formula name)</label>
                  <div className="input">
                    <input
                      name="search"
                      className="form-control"
                      id="search"
                      onChange={handleChange}
                      type="text"
                    ></input>
                  </div>
                </div>
                <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
              </div>
            </div>
          </div>
          <BootstrapTable
            classes="react-bootstrap-table"
            keyField="ID"
            maxHeight="300px"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        <p className="page-desc">There are no formula at this time</p>
      )}
    </div>
  );
};

export default CustomListTab;
